<template lang="pug">
div
  div(
    style="position:relative"
    @click="dialog = true"
    v-for="schedule in calendarShowSchedules"
    :key="schedule.id"
    :class="{[scheduleColor(schedule.type)]: true}"
  ).calendar-month--event.white--text.pa-2.mb-1
    .day-owner(v-if="user.id !== schedule.user_id")
    | {{ schedule.start_at | readableTime }}
    | -
    | {{ schedule.end_at | readableTime }}
    br
    | {{ schedule.name }}
  v-btn(
    v-if="schedules.length > 2" block
  ).calendar--event.accent.white--text.pa-2 + {{ schedules.length - 2 }}

</template>
<script>
import { mapGetters } from 'vuex';
// import { CRUDWebinarSchedule } from '../../../../services/API/_crud';
import mixinDateTime from '../../../../mixins/mixinDateTime';

export default {
  mixins: [mixinDateTime],
  props: {
    schedules: { type: Array, required: true },
    currentDate: { type: [Object, Number, Date], required: true },
    day: { type: [Number, String], required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed:{
    ...mapGetters({
      'user': 'auth/getUser',
    }),
    sortedSchedules() {
      return [...this.schedules].sort((a, b) => new Date(a).getTime() < new Date(b).getTime());
    },
    calendarShowSchedules() {
      return this.schedules.slice(0, 2);
    },
  },
  methods:{
    scheduleColor(type) {
      return {
        1: 'accent',
        2:'primary',
      }[type] || 'info';
    },
  },
};

</script>
<style lang="scss">
.day-owner{
  position: absolute;
  right: 0px;
  top: 0px;
  border-top-right-radius: 3px;
  clip-path: polygon(100% 0, 0 0, 100% 94%);
  width: 30px;
  height: 30px;
  // border-style: solid;
  // border-width: 0 30px 30px 0;
  // border-color: transparent #00ffa6 transparent transparent;
  background-color: #00ffa6;
}
</style>
